import { css } from '@emotion/css';

export const buttonContainerStyles = css`
  background-color: #52b68d;
`;
